import React from "react";
import Card from "react-bootstrap/Card";
import pdf from "../../Assets/Ravindu Dhanushka.pdf";
import { FiArrowDownCircle } from "react-icons/fi";
import Button from "react-bootstrap/Button";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi there, My name is{" "}
            <span className="purple">Ravindu Dhanushka. </span>I am an
            undergraduate student of{" "}
            <span>
              <a
                href="https://www.nsbm.ac.lk/"
                style={{ textDecoration: "none" }}
                className="purple"
                target="_blank"
                rel="noreferrer"
              >
                NSBM Green University
              </a>{" "}
            </span>
            and currently doing a{" "}
            <span>
              {" "}
              <a
                href="https://www.nsbm.ac.lk/course/bsc-hons-software-engineering/"
                className={"purple"}
                target={"_blank"}
                rel={"noopener noreferrer"}
                style={{ textDecoration: "none" }}
              >
                BSc (Hons) Software Engineering
              </a>{" "}
            </span>{" "}
            degree program. I'm a hardworking, energetic person. I can handle
            multiple tasks daily, and I always use my logical thinking and
            creative approaches to solve problems.
            <br />
            <br />
            In addition to my technical expertise and experience, I am a fast
            learner with excellent problem-solving capabilities. I am also
            highly organized and able to manage a significant workload while
            maintaining a high level of accuracy and attention to detail. I’m
            interested in{" "}
            <span className="purple">
              {" "}
              Full-Stack development . React, Java, .NET, and C#
            </span>{" "}
            are my main programming languages. and I also use Python for my
            machine learning projects. I have developed a hotel room cleaning
            management system using the{" "}
            <span className="purple"> ASP.NET framework. </span> and I also
            contributed to some open-source projects in Java J2EE. All of these
            projects are clearly explained in my CV.
            <br />
            <Button
              variant="primary"
              href={pdf}
              target="_blank"
              style={{ maxWidth: "250px", marginTop: "30px" }}
            >
              <FiArrowDownCircle />
              &nbsp;Download CV
            </Button>
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
